import React from 'react'
import { useTranslation } from 'i18n'

const ErrorScreen = ({ review, error }) => {
  const { t } = useTranslation('review')

  return (
    <div className={`product-review-error`}>
      <div className="intro">
        <h1>{t('error.title')}</h1>
        <div className="detail">
          {t('error.intro')}
          <br />
          {error && (
            <pre>
              {t('error.details', {
                error: error.error,
                message: error.message,
                timestamp: error.timestamp,
                interpolation: { escapeValue: false },
              })}
            </pre>
          )}
        </div>
      </div>
    </div>
  )
}

export default ErrorScreen
